import React, { FunctionComponent, memo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useRoute } from "wouter";

export const useNewQuoteModalState = createHashStateHook("#new-quote");

import { DealerCartRoute } from "../../../navigation/DealerRoutes";
import { useCartClear } from "../../../stores/hooks/useCartClear";
import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { createHashStateHook } from "../../../stores/useHashState";
import {
  PrimaryButton,
  PrimaryOutlinedButton,
} from "../../../ui/Button/Button";
import { Dialog } from "../../../ui/Dialog/Dialog";
import { DialogHeader } from "../../../ui/Dialog/DialogHeader";
import { getBackToResultsPath } from "../../BackToStore/BackToStore";

const Uncached: FunctionComponent = () => {
  const [visible, { hide }] = useNewQuoteModalState();
  const { t } = useTranslation();
  const [, setLocation] = useLocation();
  const cartClear = useCartClear();
  const [searchForm] = useSearchForm();
  const [isCartRoute] = useRoute(DealerCartRoute);

  return (
    <Dialog id="new-quote-modal" onClose={hide} visible={visible}>
      <DialogHeader onClose={hide} title={t("cart.newQuote")} />
      <section className="p-4 max-w-[24em]">
        {t("cart.newQuoteModalContent")}
      </section>
      <footer className="p-4 flex justify-end space-x-1">
        <PrimaryOutlinedButton aria-label="closesNewQuoteDialog" onClick={hide}>
          {t("cart.cancel")}
        </PrimaryOutlinedButton>
        <PrimaryButton
          onClick={(): void => {
            cartClear();
            hide();
            if (isCartRoute) {
              const backLink = getBackToResultsPath(searchForm);
              setLocation(backLink);
            }
          }}
          aria-label="clearCartAndContinue"
        >
          {t("cart.continue")}
        </PrimaryButton>
      </footer>
    </Dialog>
  );
};

export const NewQuoteModal = memo(Uncached);
